document.addEventListener('DOMContentLoaded', () => {
	/**
	 * Gérer l'affichage de la nav mobile
	 */
	const handleNavMobile = (e) => {
		if (window.innerWidth > 1024) return;

		const btn = document.querySelector('.toggle-mobile');
		if (!btn) {
			console.warning("missing mobile nav toggle btn");
			return;
		}

		const nav = document.querySelector('nav#site-navigation > ul');
		const main = document.querySelector('main.site-main');
		const contactBtn = nav.querySelector('#menu-item-896');
		if (window.innerWidth < 1300) {
			main.appendChild(contactBtn)
		}

		btn.onclick = (e) => {
			nav.classList.toggle('d-block');
			nav.classList.toggle('visible');
			document.body.classList.toggle('freeze');

			if (window.innerWidth < 1300) {
				if (main.contains(contactBtn)) {
					main.removeChild(contactBtn);
					nav.appendChild(contactBtn)
				} else {
					main.appendChild(contactBtn)
					nav.removeChild(contactBtn)
				}
			}
		}
		window.onclick = (e) => {
			if (!nav.classList.contains('d-block') || nav.contains(e.target) || btn.contains(e.target)) return;
			else {
				nav.classList.toggle('d-block');
				nav.classList.toggle('visible');
				document.body.classList.toggle('freeze');
			}
		}
	}
	handleNavMobile();
	window.onresize = handleNavMobile;

	/**
	 * Gérer le bouton backToTop
	 */
	const backToTopBtn = document.querySelector('#backToTop');
	const handleBackToTopScroll = () => {
		if (window.scrollY > 0) {
			if (!backToTopBtn.classList.contains('d-flex')) {
				backToTopBtn.classList.add('d-flex')
			}
		} else {
			if (backToTopBtn.classList.contains('d-flex')) {
				backToTopBtn.classList.remove('d-flex')
			}
		}
	}
	const handleBackToTopClick = () => {
		window.scroll({ top: 0, behavior: "smooth" })
	}

	if (backToTopBtn) {
		backToTopBtn.onclick = handleBackToTopClick;
		window.onscroll = handleBackToTopScroll
		handleBackToTopScroll();
	}

	/**
	 * Gérer le dark mode
	 */
	const toggleDarkMode = document.querySelector('input.toggle-dark-mode');
	const handleDarkMode = (e) => {
		let isChecked = false;
		if (e && e.type === "change") {
			isChecked = e.target.checked;
			window.localStorage.setItem('dark_mode', e.target.checked);
		} else {
			const darkMode_value = window.localStorage.getItem('dark_mode') === "true" ?? false;
			toggleDarkMode.checked = darkMode_value;
			isChecked = darkMode_value;
		}

		const hasDarkModeClass = document.body.classList.contains('dark-mode');
		const icon = document.querySelector('input.toggle-dark-mode+.icon');
		if (isChecked && !hasDarkModeClass) {
			document.body.classList.add('dark-mode');
			icon.classList.add('checked')
		} else if (!isChecked && hasDarkModeClass) {
			document.body.classList.remove('dark-mode');
			icon.classList.remove('checked')
		}
	}
	if (toggleDarkMode) {
		toggleDarkMode.onchange = handleDarkMode;
		handleDarkMode();
	}

	/**
	 * Masquer le header quand on a du SEA
	 */
	const handleNavWhenSEA = () => {
		const urlParameters = new URLSearchParams(window.location.search);
		const param = urlParameters.get('gclid');
		if (!param) return;

		const header = document.querySelector('header.site-header');
		if (!header) return;

		header.remove()
	}
	handleNavWhenSEA();
})